import styled from "@emotion/styled";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {
  Box,
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Tooltip,
  Typography,
  useTheme
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Image from 'react-bootstrap/Image';
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.svg";
import logoIcon from "../assets/images/logoIcon.svg";
import audits from "../assets/images/sideIcons/audits.png";
import brands from "../assets/images/sideIcons/brands.png";
import campaign from "../assets/images/sideIcons/campaign.png";
import company from "../assets/images/sideIcons/company.png";
import dashboard from "../assets/images/sideIcons/dashboard.png";
import kyc from "../assets/images/sideIcons/kyc.png";
import mycampaigns from "../assets/images/sideIcons/mycampaign.png";
import notification from "../assets/images/sideIcons/notification.png";
import privacy from "../assets/images/sideIcons/privacy.png";
import roles from "../assets/images/sideIcons/roles.png";
import setting from "../assets/images/sideIcons/setting.png";
import subscription from "../assets/images/sideIcons/subscription1.png";
import discovery from "../assets/images/sideIcons/discoverInfluencer.png"
import ultimateDiscovery from "../assets/images/sideIcons/discoverInfluencer.png"
import usermgt from "../assets/images/sideIcons/usermgt.png";
import users from "../assets/images/sideIcons/users.png";
import wallet from "../assets/images/sideIcons/wallet.png";
import { getUserInfoNew } from "../layout/action";
import { useGetUserDetailsQuery } from "../redux/api";
import { getCompanyid, getFormatedNumber, getUserType } from "../utils/common";
import { COMPANY, getFixedValue, getFixedValueToNonDecimal, trunCateString } from "../utils/constant";
import { ROUTES } from "../utils/routes";
import creditWhite from '../assets/images/icons/creditwhite.svg'
import infoWhite from '../assets/images/icons/infowhite.svg'
import myPlanIcon from '../assets/images/icons/myplan.svg'
import questionCircle from '../assets/images/icons/questionCircle.svg'
import questiongray from '../assets/images/icons/questiongray.svg'
import coinsGold from '../assets/images/icons/goldcoin2.svg'
import diamond from '../assets/images/icons/diamond.svg'
import userCheck from '../assets/images/icons/usercheck2.svg'
import rocket from '../assets/images/icons/rocket2.svg'
import { getActivePlanDetails } from "../pages/subscriptions/action";
import list from '../assets/images/sideIcons/listSidebaricon.svg'
import { setSidebar } from "../redux/reducer";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
const sidebarData = [
  {
    title: "Dashboard",
    endpoint: "/",
    type: "dashboard",
    icon: dashboard,
    userType: ["admin", "brand", "company"],
    isActive: ["dashboard"],
    items: []
  },
  {
    title: "old-discovery",
    endpoint: ROUTES.DISCOVER_INFLUNCERS,
    icon: discovery,
    userType: [],
    type: "influncers",
    isActive: ["discover-influencers"],
    items: []
  },
  {
    title: "Discovery",
    endpoint: ROUTES.ULTIMATE_DISCOVER,
    icon: ultimateDiscovery,
    userType: ["admin", "company"],
    type: "ultimateDiscover",
    isActive: ["discover"],
    items: []
  },
  {
    title: "List",
    endpoint: "/list",
    type: "list",
    icon: list,
    userType: ["brand", "company"],
    isActive: ["list"],
    items: []
  },
  {
    title: "Wallet",
    endpoint: "/wallet",
    type: "wallet",
    icon: wallet,
    userType: ["admin", "brand", "company"],
    isActive: ["wallet"],
    items: []
  },
  {
    title: "Creator Management",
    endpoint: ROUTES.USER_MANAGEMENT,
    icon: usermgt,
    type: "users",
    userType: ["admin"],
    isActive: ["userManagement", 'createInfluencer', 'editInfluencer'],
    items: []
  },

  {
    title: "My Campaigns",
    endpoint: ROUTES.MY_CAMPAIGNS,
    icon: mycampaigns,
    userType: ["brand", "company"],
    type: "myCampaign",
    isActive: ["my-campaign", "campaign"],
    items: []
  },

  {
    title: "Credit Management",
    icon: subscription, // Using campaign icon as placeholder
    userType: ["admin"],
    type: "creditManagement",
    isActive: ["credit-management", "requested-inflyx-coins", "credit-list", "delink-requests", "withdrawal-requests", "influencer-insights"],
    items: [
      {
        title: "Request Inflyx Coins",
        endpoint: ROUTES.REQUESTED_INFLYX_COINS,
        isActive: ["requested-inflyx-coins"],
      },
      {
        title: "Credit List view",
        endpoint: ROUTES.CREDIT_LIST,
        isActive: ["credit-list"],
      },
      {
        title: "Withdrawal Requests",
        endpoint: ROUTES.WITHDRAWAL_REQUESTS,
        isActive: ["withdrawal-requests"],
      },
      {
        title: "Influencer Insights",
        endpoint: ROUTES.INFLUENCER_INSIGHTS,
        isActive: ["influencer-insights"],
      },
      {
        title: "Delink requests",
        endpoint: ROUTES.DELINK_REQUESTS,
        isActive: ["delink-requests"],
      }
    ]
  },
  {
    title: "Company Management",
    endpoint: ROUTES.COMPANIES,
    icon: company,
    type: "company",
    userType: ["admin",],
    isActive: ["companies", "company"],
    items: []
  },

  {
    title: "Brands",
    endpoint: ROUTES.BRANDS_FOR_COMPANY,
    icon: brands,
    type: "brand",
    userType: ["brand", "company"],
    isActive: ["brands"],
    items: []
  },
  {
    title: "Campaign Management",
    endpoint: ROUTES.CAMPAIGN_MANAGEMENT,
    icon: campaign,
    type: "campaign",
    userType: ["admin"],
    isActive: ["campaign", "my-campaigns"],
    items: []
  },
  {
    title: "Influ. Campaign Mgt.",
    // endpoint: ROUTES.CAMPAIGN_BY_INFLUENCER_LIST,
    icon: campaign,
    userType: ["brand", "company", "admin"],
    type: "campaignByInfluencer",
    isActive: ["campaign-by-influencer", "all-bills"],
    items: [
      {
        title: "Campaign by Influencer",
        endpoint: ROUTES.CAMPAIGN_BY_INFLUENCER_LIST,
        isActive: ["campaign-by-influencer"],
      },
      {
        title: "All Bills",
        endpoint: ROUTES.ALL_BILLS,
        isActive: ["all-bills"],
      }
    ]
  },
  {
    title: "Admin User",
    endpoint: ROUTES.ADMIN_USERS,
    icon: users,
    type: "adminUsers",
    userType: ["admin"],
    isActive: ["adminUsers"],
    items: []
  },
  {
    title: "Roles & Rights Mgt.",
    endpoint: ROUTES.ROLES_AND_RIGHTS,
    icon: roles,
    userType: ["admin"],
    type: "roleAndRights",
    isActive: ["roles"],
    items: []
  },
  {
    title: "Subscription  Mgt.",
    // endpoint: ROUTES.SUBSCRIPTION_MGT,
    icon: subscription,
    type: "roleAndRights",
    userType: ["admin"],
    isActive: ["subscriptions", "subscription", "influencerSubscriptionList", 'createInfluencerSubscription', 'editInfluencerSubscription'],
    items: [
      {
        title: "Company Subscription",
        endpoint: ROUTES.SUBSCRIPTION_MGT,
        isActive: ["subscriptions", "subscription"],
      },
      {
        title: "Influencer Subscription",
        endpoint: ROUTES.INFLUENCER_SUBSCRIPTION_LIST,
        isActive: ["influencerSubscriptionList", 'createInfluencerSubscription', 'editInfluencerSubscription'],
      }
    ]
  },
  //  {
  //   title: "Influencer Subscription",
  //   endpoint: ROUTES.INFLUENCER_SUBSCRIPTION_LIST,
  //   icon: usermgt,
  //   type: "users",
  //   userType: ["admin"],
  //   isActive: ["influencerSubscriptionList", 'createInfluencerSubscription', 'editInfluencerSubscription'],
  //   items: []
  // },
  {
    title: "Notifications",
    icon: notification,
    type: "notification",
    userType: ["admin"],
    isActive: ["notification"],
    items: [
      {
        title: "Notification Groups",
        endpoint: ROUTES.GROUP_NOTIFICATION,
        isActive: ["group", 'group-edit', 'add'],
      },
      {
        title: "Community Posts",
        endpoint: ROUTES.COMMUNITY_POSTS,
        isActive: ["communityposts", 'edit', 'add'],
      },
      {
        title: "Notification Editor",
        endpoint: ROUTES.NOTIFICATION_EDITOR,
        isActive: ["editor"],
      },
      {
        title: "Notification History",
        endpoint: ROUTES.NOTIFICATION_HISTORY,
        isActive: ['history', 'edit'],
      }
    ]
  },
  {
    title: "Subscriptions",
    icon: subscription,
    type: "subscription",
    userType: ["company"],
    isActive: ["subscriptions", "subscription"],
    items: [
      {
        title: "Subscription Plan",
        endpoint: ROUTES.SUBSCRIPTION_FOR_COMPANY,
        isActive: ['active'],
        icon: subscription,
      },
      {
        title: "Subscription History",
        endpoint: ROUTES.SUBSCRIPTION_HISTORY,
        isActive: ['history'],
        icon: subscription,
      }
    ]
  },
  {
    title: "Audit Trail",
    endpoint: ROUTES.AUDIT_TRAILS,
    icon: audits,
    type: "auditTrail",
    userType: ["admin"],
    isActive: ["auditTrails"],
    items: [

    ]
  },
  {
    title: "KYC",
    endpoint: ROUTES.KYC,
    icon: kyc,
    type: "kyc",
    userType: ["admin"],
    isActive: ["kyc"],
    items: [

    ]
  },
  {
    title: "Settings",
    icon: setting,
    type: "settings",
    userType: ["admin"],
    isActive: ["app-versions"],
    items: [
      {
        title: "App Versions",
        endpoint: ROUTES.APP_VERSIONS_LIST,
        isActive: ["app-versions"],
      },
      {
        title: "Privacy policy",
        endpoint: ROUTES.PRIVACY_POLICY,
        isActive: ["privacyPolicy"],
      }
    ]
  },
  // Read-only monitoring for the API logger, the rate limiter and live sessions.
  // `securityLogs` is not a backend permission key, so the `!== 0` visibility
  // check passes; access is really controlled by userType + the admin-gated API.
  {
    title: "Security & Logs",
    icon: setting,
    type: "securityLogs",
    userType: ["admin"],
    isActive: ["security"],
    items: [
      {
        title: "API Logs",
        endpoint: ROUTES.SECURITY_API_LOGS,
        isActive: ["api-logs"],
      },
      {
        title: "Rate Limits",
        endpoint: ROUTES.SECURITY_RATE_LIMITS,
        isActive: ["rate-limits"],
      },
      {
        title: "Blocked IPs",
        endpoint: ROUTES.SECURITY_BLOCKED,
        isActive: ["blocked"],
      },
      {
        title: "Active Sessions",
        endpoint: ROUTES.SECURITY_SESSIONS,
        isActive: ["sessions"],
      }
    ]
  },
  // {
  //   title: "Privacy policy",
  //   endpoint: ROUTES.PRIVACY_POLICY,
  //   icon: privacy,
  //   type: "privacyPolicy",
  //   userType: ["admin"],
  //   isActive: ["privacyPolicy"],
  //   items: []
  // },

];

const HoveredList = styled(List)(({ theme, sx }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  height: "100vh",
  overflowY: "auto",
  zIndex: '99',
  padding: '0px 16px',
  transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,

  overflowX: "hidden",
  ...sx,
}));

const StyledListItem = styled(ListItemButton)(() => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "0px 3px",
  borderRadius: "15px",

  color: "#6C7692",
  position: "relative",
  "&:hover, &.active": {
    background: 'rgba(0, 119, 255, 0.10)',
    color: "rgba(0, 119, 255, 1)",
    "& .listItemIcon": {
      color: "rgba(0, 119, 255, 1)",
    },
  },
}));
const Sidebar = () => {
  const theme = useTheme();
  const states = useSelector((state) => state.app);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const timerRef = useRef(null);
  const [open, setOpen] = useState(location?.pathname?.split("/")[1]);
  const [type, setType] = useState(-1);
  const {
    planDetails, planDetailsLoaded } = useSelector((state) => state.subscriptionSlice);
  const [anchorEl, setAnchorEl] = useState(null);

  const userType = JSON.parse(localStorage.getItem("user"));
  let sideBarJson = [];
  if (userType?.userType === "company") {
    sideBarJson = {
      brands: { edit: 1, view: 1, create: 1, delete: 1 },
      users: { edit: 1, view: 1, create: 1, delete: 1 },
      myCampaigns: { edit: 1, view: 1, create: 1, delete: 1 },
      dashboard: { edit: 1, view: 1, create: 1, delete: 1 },
      searchInculencer: { edit: 1, view: 1, create: 1, delete: 1 },
    }
  }
  else {
    sideBarJson = sidebarData.reduce((acc, item) => {
      const type = item.type;
      acc[type] = { edit: 1, view: 1, create: 1, delete: 1 };
      return acc;
    }, {});
  }

  useEffect(() => {
    dispatch(getUserInfoNew(userType?.id));
  }, []);

  // The company id has to be read reactively. On a fresh login it is not in
  // localStorage yet — the header writes it only once getUserDetails resolves —
  // so a value captured at module load stayed null forever, the fetch below
  // never fired, and the credits pill rendered 0 until a manual reload.
  // RTK Query dedupes this against the header's identical query, so sharing it
  // costs no extra request.
  const { data: userDetails } = useGetUserDetailsQuery(userType?.id, { skip: !userType?.id });
  const companyId = userDetails?.result?.companyId || userDetails?.result?.id || getCompanyid();

  useEffect(() => {
    if (companyId) {
      dispatch(getActivePlanDetails(companyId));
    }
  }, [companyId, dispatch])


  const handleToggleSidebar = (e) => {
    e.preventDefault();
    if (states.fromSidebarButton) return;
    if (timerRef.current) return;
    dispatch(setSidebar({ fromSidebarButton: false }));
  };

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      timerRef.current = null;
    }, 200);
  }, [states.sidebar])

  const { basicInfo } = planDetails || {};
  const usedValues = [
    basicInfo?.useSearchView,
    basicInfo?.useProfileView,
    basicInfo?.usePhoneNumber,
    basicInfo?.useEmail,
    basicInfo?.useInfluencerApproved,
    basicInfo?.usePaid,
    basicInfo?.useBarter,
    basicInfo?.useAffiliate,
    basicInfo?.usePerformance
  ];

  const actualValues = [
    basicInfo?.actualSearchView,
    basicInfo?.actualProfileView,
    basicInfo?.actualPhoneNumber,
    basicInfo?.actualEmail,
    basicInfo?.actualInfluencerApproved,
    basicInfo?.actualPaid,
    basicInfo?.actualBarter,
    basicInfo?.actualAffiliate,
    basicInfo?.actualPerformance
  ];


  const sumValues = (values) =>
    values.reduce((acc, val) => acc + getFormatedNumber(val), 0);

  const usedTotal = sumValues(usedValues);
  const actualTotal = sumValues(actualValues);
  // Until the plan call resolves every total is 0, which reads as "no credits
  // left" rather than "still loading". Show a placeholder instead of a number.
  const remainingLabel = planDetailsLoaded
    ? getFixedValueToNonDecimal(actualTotal - usedTotal)
    : "–";

  const isSideBarOpen = states.sidebarWidth === "255px";
  return (
    states.permissions && (
      <>
        <HoveredList
          onMouseEnter={handleToggleSidebar}
          onMouseLeave={handleToggleSidebar}
          className={`sidebar ${!states.sidebar ? 'activeSidebar' : ''}`}
          sx={{
            maxWidth: anchorEl ? "255px" : states.sidebarWidth,
            width: anchorEl ? "255px" : "100%",
            backgroundColor: "background.paper",
            zIndex: 1000,
          }}
        >
          <Link to="/" className="sidebarLogo">
            <Box className="fullLogo" component="img" src={logo}
              sx={{ visibility: anchorEl && "visible !important", opacity: anchorEl && "1 !important", width: anchorEl && 'fit-content !important' }}
            ></Box>
            <Box className="logoIcon" component="img" src={logoIcon}
              sx={{ visibility: anchorEl && "hidden !important", opacity: anchorEl && "0 !important" }}
            ></Box>
          </Link>
          <div className="closeSidebar" onClick={handleToggleSidebar}>
            <KeyboardDoubleArrowLeftIcon />
          </div>
          {states.permissions && sidebarData.map((item, index) =>
            (states.permissions?.[item.type]?.view !== 0 || item.type === "campaignByInfluencer" || item.type === "requestedInflyxCoins" || item.type === "delinkRequests") &&
            item?.userType?.includes(JSON.parse(localStorage.getItem("user"))?.userType) && (
              <React.Fragment key={index}>
                <ListItem onClick={() => {
                  if (item.items.length > 0) {
                    setType((prevType) => prevType === item.type ? -1 : item.type);
                    setOpen((prevOpen) => prevOpen === item.type ? "" : item.type);
                  } else {
                    navigate(item.endpoint);
                  }
                }}>

                  <StyledListItem
                    className={item?.isActive?.includes(location?.pathname?.split("/")[1]) ? "active" : ""}
                    disableRipple
                    component={item.items.length > 0 ? 'div' : NavLink}
                    to={item.items.length === 0 ? item.endpoint : false}>
                    <ListItemIcon className="listItemIcon" sx={{
                      visibility: anchorEl && "visible",
                      opacity: anchorEl && "1",
                    }} >
                      <Image src={item.icon} className='img-fluid' alt="" />
                    </ListItemIcon>
                    <ListItemText sx={{
                      visibility: anchorEl && "visible !important",
                      opacity: anchorEl && "1 !important",
                    }} className="tabText m-0" disableTypography primary={item.title} />
                    {item.items.length > 0 && (open === item.type ? <ExpandLess sx={{ display: anchorEl && "block !important", }} /> : <ExpandMore sx={{ display: anchorEl && "block !important", }} />)}
                  </StyledListItem>
                </ListItem>
                {item.items.length > 0 && (
                  <Collapse className="dropParent" in={open === item.type} timeout="auto" unmountOnExit>
                    {item.items.map((v, subIndex) => (
                      <List sx={{
                        visibility: anchorEl && "visible !important",
                        opacity: anchorEl && "1 !important",
                      }} component="div" className="dropIt" disablePadding key={subIndex}>
                        <ListItemButton sx={{ pl: 6 }}
                          className={v?.isActive?.includes(location?.pathname?.split("/")?.slice(-1)?.pop()) ? "activeItem" : ""}
                          onClick={() => navigate(v.endpoint)}
                        >
                          <div className="bulletIcon"></div>
                          <div className="textSubTab">{v.title}</div>
                        </ListItemButton>
                      </List>
                    ))}
                  </Collapse>
                )}
              </React.Fragment>
            )
          )}
          {getUserType() === COMPANY && <ListItem
            className="versionControl"
            sx={{
              paddingX: "16px",
              marginY: '16px',
              display: "flex",
              bottom: "20px",
              justifyContent: "center",
              position: "absolute",
              left: '0px',
              transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,
            }}
          >
            <Tooltip placement="bottom-start" arrow componentsProps={{
              tooltip: {
                sx: {
                  marginTop: '3px !important', marginLeft: '10px',
                  backgroundColor: "white !important",
                  color: "black !important",
                  borderRadius: '5px',
                  boxShadow: '0px 0px 24px 0px #0077FF33',
                  display: isSideBarOpen ? "block" : "none",
                  width: '363px', height: '194px', paddingX: '0 !important', paddingY: '5px !important', maxWidth: '100%'
                },
              },
              arrow: {
                sx: {

                  color: "transparent !important",
                  "&::before": {
                    backgroundColor: "transparent",
                  },
                },
              },
            }} title={<UserInfo planDetails={planDetails} usedTotal={usedTotal} actualTotal={actualTotal} />}>
              <Box sx={{ height: '40px !important', border: '0px solid red', background: 'linear-gradient(127deg, rgba(7,213,255,1) 0%, rgba(16,34,121,1) 50%, rgba(188,150,255,1) 100%) !important', padding: '2px !important', borderRadius: '50px !important', width: 'fit-content', overflow: 'hidden', marginX: '10px' }}>
                <Stack sx={{ height: '100%', background: 'white', borderRadius: '50px', overflow: 'hidden', width: '100%', paddingX: isSideBarOpen ? '20px' : '10px' }} direction="row" justifyContent={"space-between"} alignItems="center" gap={4} >
                  <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} gap={0.5} sx={{ height: '100%', }}>
                    <img style={{ height: '12px', width: '12px', filter: 'grayscale(0.7) sepia(0.4) brightness(0.4) contrast(1.1) hue-rotate(0deg) saturate(0.7)' }} src={creditWhite} alt="creditWhite" />
                    <Typography color={"#726C6C"} fontSize={12} fontWeight={600}>{trunCateString(remainingLabel, isSideBarOpen ? 10 : 2)} {isSideBarOpen && <span>Credits Remai..</span>}</Typography>
                  </Stack>
                  {isSideBarOpen && <img src={infoWhite} alt="infowhite" style={{ height: '12px', width: '12px', filter: 'grayscale(0.7) sepia(0.4) brightness(0.4) contrast(1.1) hue-rotate(0deg) saturate(0.7)' }} />}
                </Stack>
              </Box></Tooltip>
          </ListItem>}
        </HoveredList>

      </>
    )
  );
};

export default Sidebar;


const UserInfo = ({ planDetails, usedTotal, actualTotal }) => {

  return (
    <>
      <Stack direction="column" gap={1} sx={{ height: '100%', width: '100%', background: 'white', borderRadius: '8px', padding: '0px 15px' }} >
        <Stack direction="row" justifyContent="space-between" alignItems="center" >
          <Typography sx={{ fontWeight: '700', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center' }}>
            <img src={myPlanIcon} alt="myPlanIcon" height={24} width={24} />&nbsp;My Plan&nbsp;<img src={questionCircle} alt="questionCircle" width={16} height={16} />
          </Typography>
          <Typography sx={{ fontWeight: '700', fontFamily: "var(--family1)", fontSize: '14px', background: 'linear-gradient(127deg, rgba(7,213,255,1) 0%, rgba(16,34,121,1) 50%, rgba(188,150,255,1) 100%)', backgroundClip: "text", color: 'transparent', textTransform: 'capitalize' }}>{trunCateString(planDetails?.basicInfo?.name, 15) || "N/A"}</Typography>
        </Stack>
        <hr />
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center' }}>
            <img src={coinsGold} alt="myPlanIcon" height={24} width={24} />&nbsp;Credit Remains&nbsp;<img src={questionCircle} alt="questionCircle" width={16} height={16} />
          </Typography>
          <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', }}>{getFixedValueToNonDecimal(actualTotal - usedTotal) + "/" + getFixedValueToNonDecimal(actualTotal)}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center', color: '#726C6C' }}>
            <img src={userCheck} alt="myPlanIcon" height={24} width={24} />&nbsp;Approved Influencers&nbsp;<img src={questiongray} alt="questionCircle" width={16} height={16} />
          </Typography>
          <Typography onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }} sx={{ fontWeight: '600', fontFamily: "var(--family1)", fontSize: '12px', display: 'flex', alignItems: 'center', color: 'white', padding: '5px 10px', borderRadius: '5px', zIndex: '99999999 !important' }} className="upgradePlanButton-hover upgradePlanButton">
            <Link to={`/subscription/active/details/${getCompanyid()}`} className="text-decoration-none" style={{ color: 'white' }}> <img src={diamond} alt="myPlanIcon" height={18} width={18} /> Upgrade</Link>
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontWeight: '500', fontFamily: "var(--family1)", fontSize: '14px', display: 'flex', alignItems: 'center', color: '#726C6C' }}>
            <img src={rocket} alt="myPlanIcon" height={24} width={24} />&nbsp;Create Campaign &nbsp;<img src={questiongray} alt="questionCircle" width={16} height={16} />
          </Typography>
          <Typography onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }} sx={{ fontWeight: '600', fontFamily: "var(--family1)", fontSize: '12px', display: 'flex', alignItems: 'center', color: 'white', padding: '5px 10px', borderRadius: '5px', zIndex: '99999999 !important' }} className="upgradePlanButton-hover upgradePlanButton">
            <Link to={`/subscription/active/details/${getCompanyid()}`} className="text-decoration-none" style={{ color: 'white' }}> <img src={diamond} alt="myPlanIcon" height={18} width={18} /> Upgrade</Link>
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontWeight: '700', fontFamily: "var(--family1)", fontSize: '14px', background: 'linear-gradient(127deg, rgba(7,213,255,1) 0%, rgba(16,34,121,1) 50%, rgba(188,150,255,1) 100%)', backgroundClip: "text", color: 'transparent' }}>Need More credits...</Typography>
          <Typography onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }} sx={{ fontWeight: '600', fontFamily: "var(--family1)", fontSize: '12px', display: 'flex', alignItems: 'center', color: 'white', padding: '5px 10px', borderRadius: '5px', zIndex: '99999999 !important' }} className="upgradePlanButton-hover upgradePlanButton">
            <Link to={`/subscription/active/details/${getCompanyid()}`} className="text-decoration-none" style={{ color: 'white' }}> <img src={diamond} alt="myPlanIcon" height={18} width={18} /> Upgrade Plan</Link>
          </Typography>
        </Stack>
      </Stack>
    </>
  )
}